import {
	X,
	SunMedium,
	Moon,
	Star,
	Share,
	Megaphone,
	ArrowLeft,
	LogIn,
	LogOut,
	Bookmark,
	Video,
	Home,
	Map as MapIcon,
	Building2,
	Globe,
	MapPin,
	User,
	Wifi,
	WifiOff,
	Pencil,
	AlertTriangle,
	ChevronDown,
	ChevronUp,
	List,
	CalendarDays,
	Play,
	Clock,
	AlertCircle,
	Download,
	Upload,
	Users,
	ExternalLink,
	Search,
	Check,
	RefreshCw,
	Folder,
	FileText,
	Target,
	Gauge,
	TrendingUp,
	TrendingDown,
	Minus,
} from "lucide-react";

const TwitterIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		aria-hidden="true"
		focusable="false"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
	</svg>
);

const GitLabIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		aria-hidden="true"
		focusable="false"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z" />
	</svg>
);

export const Icons = {
	logo: (props: React.SVGProps<SVGSVGElement>) => (
		<svg aria-hidden="true" focusable="false" viewBox="0 0 64 64" {...props}>
			<rect width="64" height="64" rx="18" fill="#115e59" />
			<g
				fill="none"
				stroke="#f0fdfa"
				strokeWidth="6"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M18 16v11a5 5 0 0 0 5 5h22" />
				<path d="M18 48V37a5 5 0 0 1 5-5" />
				<path d="M34 16v6a10 10 0 0 0 10 10" />
			</g>
			<circle cx="45" cy="32" r="7" fill="#fbbf24" />
		</svg>
	),
	login: LogIn,
	logout: LogOut,
	arrowLeft: ArrowLeft,
	close: X,
	sun: SunMedium,
	moon: Moon,
	star: Star,
	share: Share,
	megaphone: Megaphone,
	home: Home,
	video: Video,
	bookmark: Bookmark,
	map: MapIcon,
	building: Building2,
	globe: Globe,
	twitter: TwitterIcon,
	mapPin: MapPin,
	user: User,
	wifi: Wifi,
	wifiOff: WifiOff,
	pencil: Pencil,
	alertTriangle: AlertTriangle,
	chevronDown: ChevronDown,
	chevronUp: ChevronUp,
	list: List,
	calendar: CalendarDays,
	play: Play,
	alertCircle: AlertCircle,
	gitHub: ({ ...props }) => (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fab"
			data-icon="github"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 496 512"
			{...props}
		>
			<path
				fill="currentColor"
				d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
			/>
		</svg>
	),
	discord: ({ ...props }) => (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fab"
			data-icon="discord"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512"
			{...props}
		>
			<path
				fill="currentColor"
				d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.823,1.064,334.6,334.6,0,0,0-14.9,30.276,447.8,447.8,0,0,0-134.426,0,309.471,309.471,0,0,0-15.135-30.276,1.89,1.89,0,0,0-1.824-1.064A483.689,483.689,0,0,0,116.084,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,31.352,294.69,74.643,403.723a1.8,1.8,0,0,0,.653,1.015,485.141,485.141,0,0,0,140.197,70.576,1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,236.4,433.378a1.86,1.86,0,0,0-1.961-2.627,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.923-.263,390.25,390.25,0,0,0,189.36,44.983,1.825,1.825,0,0,1,1.923.263c2.944,2.426,6.027,4.828,9.111,7.137a1.884,1.884,0,0,1-.186,3.126,320.289,320.289,0,0,1-45.885,21.853,1.875,1.875,0,0,0-1.953,2.629,344.736,344.736,0,0,0,12.819,25.653,1.877,1.877,0,0,0,2.059.608A485.518,485.518,0,0,0,615.771,404.7a1.882,1.882,0,0,0,.654-1.008C660.73,294.69,652.965,183.658,524.531,69.836ZM224.757,300.839a41.195,41.195,0,1,1,41.2-41.225A41.052,41.052,0,0,1,224.757,300.839Zm190.5,0a41.195,41.195,0,1,1,41.2-41.225A41.052,41.052,0,0,1,415.264,300.839Z"
			/>
		</svg>
	),
	mastodon: ({ ...props }) => (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fab"
			data-icon="mastodon"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			xmlSpace="preserve"
			viewBox="0 0 512 512"
			{...props}
		>
			<path
				d="M494.3 113.4C486.9 58.3 439 15 382.1 6.6 372.5 5.2 336.2 0 252 0h-.6c-84.2 0-102.2 5.2-111.8 6.6-55.3 8.2-105.7 47.1-118 102.8-5.9 27.4-6.5 57.8-5.4 85.7 1.6 40 1.9 79.9 5.5 119.7 2.5 26.4 6.9 52.7 13.1 78.5 11.6 47.7 58.7 87.4 104.9 103.6 49.4 16.9 102.6 19.7 153.5 8.1 5.6-1.3 11.1-2.8 16.6-4.5 12.4-3.9 26.9-8.3 37.5-16.1.1-.1.3-.2.4-.4s.1-.3.1-.5v-38.6c0-.2 0-.3-.1-.5s-.2-.3-.3-.4-.3-.2-.5-.2h-.5c-32.6 7.8-66.1 11.7-99.6 11.6-57.7 0-73.2-27.4-77.7-38.8-3.6-9.9-5.8-20.1-6.7-30.6 0-.2 0-.4.1-.5.1-.2.2-.3.3-.4s.3-.2.5-.2h.5c32.1 7.7 65 11.6 98 11.6 7.9 0 15.8 0 23.8-.2 33.2-.9 68.2-2.6 100.8-9 .8-.2 1.6-.3 2.3-.5 51.5-9.9 100.5-40.9 105.5-119.5.2-3.1.7-32.4.7-35.6-.1-11 3.4-77.5-.6-118.3"
				fill="currentColor"
			/>
			<path
				d="M412.7 175.2v136.7h-54.2V179.2c0-27.9-11.6-42.2-35.3-42.2-26 0-39.1 16.8-39.1 50.1v72.6h-53.8v-72.6c0-33.3-13.1-50.1-39.1-50.1-23.5 0-35.3 14.2-35.3 42.2v132.6h-54.1V175.2c0-27.9 7.1-50.1 21.4-66.6 14.7-16.4 34-24.8 58-24.8 27.7 0 48.7 10.7 62.6 32l13.5 22.6 13.5-22.6c14-21.3 34.9-32 62.6-32 23.9 0 43.2 8.4 58 24.8q21.3 24.6 21.3 66.6"
				fill="#6364FF"
			/>
		</svg>
	),
	gitlab: GitLabIcon,
	clock: Clock,
	download: Download,
	upload: Upload,
	users: Users,
	search: Search,
	externalLink: ExternalLink,
	x: X,
	check: Check,
	refresh: RefreshCw,
	folder: Folder,
	fileText: FileText,
	target: Target,
	gauge: Gauge,
	trendingUp: TrendingUp,
	trendingDown: TrendingDown,
	minus: Minus,
};
